import React from 'react'

import { useSelector } from 'react-redux'

import DynamicFeatureProvider from 'components/DynamicFeatureProvider'
import { useConfiguration } from 'components/DynamicFeatureProvider/use-configuration'
import { selectPermissions } from 'store/user'
import { TPermission } from 'store/user/type-definitions'

import features from './features'

interface IConfiguredDynamicFeatureProviderProps {
  children: React.ReactNode
}

const ConfiguredDynamicFeatureProvider = ({ children }: IConfiguredDynamicFeatureProviderProps) => {
  const permissions: TPermission[] = useSelector(selectPermissions)
  const configuration = useConfiguration({ features, permissions })
  return <DynamicFeatureProvider configuration={configuration}>{children}</DynamicFeatureProvider>
}

export default ConfiguredDynamicFeatureProvider
